import React from "react";
import * as Yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";

import { useAppDispatch, useAppSelector } from "@/redux/store";
import { addPassword } from "@/redux/profile/settings/changePass/slice";
import { fetchSendNewPassword } from "@/redux/profile/settings/changePass/asyncActions";
import { fetchAuth } from "@/redux/profile/authAndReg/asyncActions";

import { Button, PasswordInput } from "@/components";

import styles from "./NewPasswordForm.module.scss";

import passwordIcon from "@/assets/icons/password.svg";

import { ValidMessages } from "@/resources/locale";
import { SubmitValueType } from "./types";
import { cleanPhone } from "@/utils/form/phoneMask";

type NewPasswordFormProps = {
  handleSubmitForm?: () => void
}
export const NewPasswordForm: React.FC<NewPasswordFormProps> = (props) => {
  const { handleSubmitForm } = props
  const dispatch = useAppDispatch();
  const { phone } = useAppSelector(state => state.changePass);
  const [errorMessage, setErrorMessage] = React.useState("");

  const initialValues = {
    password: "",
    passwordRepeat: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .required(ValidMessages.inputs.password.REQUIRED)
      .min(6, ValidMessages.inputs.password.NOT_FULL),
    passwordRepeat: Yup.string()
      .required(ValidMessages.inputs.passwordRepeat.REQUIRED)
      .oneOf([Yup.ref("password"), null], ValidMessages.inputs.passwordRepeat.NOT_MATCH),
  });

  const handleSubmit = async (values: SubmitValueType, { setSubmitting }: any) => {
    try {
      setErrorMessage("");
      const data = {
        phone,
        password: values.password
      }
  
      // Сначала обновляем пароль
      await dispatch(fetchSendNewPassword(data)).unwrap();
      
      // После успешного обновления пароля автоматически авторизуем пользователя
      const authData = {
        phone: cleanPhone(phone),
        password: values.password
      };
      
      await dispatch(fetchAuth(authData)).unwrap();
      
      // После успешной авторизации модалка закроется автоматически через useEffect в PassChangeModal
      // Не вызываем handleSubmitForm, так как пользователь будет авторизован и модалка закроется
    } catch (error: any) {
      setErrorMessage(error?.payload || error?.message || "Ошибка записи нового пароля");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={true}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <PasswordInput
                name="password"
                lable="Введите новый пароль"
                placeholder="********"
                variant="outlined"
              />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="password"
              />
            </div>
            <div className={styles.formSection}>
              <PasswordInput
                name="passwordRepeat"
                lable="Повторите пароль"
                placeholder="********"
                variant="outlined"
              />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="passwordRepeat"
              />
            </div>
            {
              errorMessage && (
                <div className={styles.errorMessage}>
                  {errorMessage}
                </div>
              )
            }
            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting}
            >
              Сохранить и войти
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
